import { useEffect, useState } from 'react';
import './loading.scss';

type Props = {
  hasCounter?: boolean;
  isSmall?: boolean;
};

const Loading = ({ hasCounter, isSmall }: Props) => {
  const [counter, setCounter] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      const maximumPercentage = 100;

      if (counter < maximumPercentage) {
        setCounter(counter + 1);
      }
    }, 50);
    return () => clearInterval(interval);
  }, [counter]);

  return (
    <div
      className="loading"
      data-testid="loading"
      style={{ height: hasCounter || isSmall ? '100%' : '100vh' }}
    >
      {hasCounter && <span className="loading__counter">{counter}%</span>}
      <div className="loading__spinner"> </div>
    </div>
  );
};

Loading.defaultProps = {
  hasCounter: false,
  isSmall: false,
};

export default Loading;
